
import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import axiosInstance from "./axios"

export async function getCompany() {
    let url = `${BASE_URL}/api/company`;

    const res = await axiosInstance.get(url)
    return res.data.Data;
}


export async function updateCompany(data) {
    let url = `${BASE_URL}/api/company`;

    const res = await axiosInstance.put(url, data)
    return res.data.Data;
}

export async function deleteCompanyAccount(password) {
    let url = `${BASE_URL}/api/company/delete`;

    const res = await axiosInstance.get(url)
    return res.data;
}
